import src from "IMAGE";
export default { src, width: 928, height: 235, blurWidth: 0, blurHeight: 0};
